"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var useField_1 = require("../../../hooks/useField");
// import { translate, TranslationKey } from "src/services/translation"
var phoneNumbers_1 = require("../../../util/phoneNumbers");
var react_input_mask_1 = __importDefault(require("../../../vendor/react-input-mask"));
var string_1 = require("../../../vendor/react-input-mask/utils/string");
var common_1 = require("../common");
var ErrorMessage_1 = __importDefault(require("../common/ErrorMessage"));
var CountrySelect_1 = __importDefault(require("./CountrySelect"));
var Wrapper = styled_components_1.default(common_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n"], ["\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: row;\n"])));
var NationalNumberWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1;\n  position: relative;\n  margin-left: -4px;\n"], ["\n  flex: 1;\n  position: relative;\n  margin-left: -4px;\n"])));
var PhoneField = function (props) {
    var format = props.format, disabled = props.disabled, name = props.name;
    var _a = useField_1.useField(props), field = _a[0], meta = _a[1], helpers = _a[2];
    var onBlur = field.onBlur;
    var error = meta.error, touched = meta.touched, value = meta.value;
    var showError = Boolean(error && touched);
    var formikSetValue = helpers.setValue;
    var setValue = function (internationalCode, nationalNumber) {
        formikSetValue({ internationalCode: internationalCode, nationalNumber: nationalNumber });
    };
    var inputMaskEl = react_1.default.useRef(null);
    var handleInternationalCode = function (newValue) {
        setValue(newValue || "", (value === null || value === void 0 ? void 0 : value.nationalNumber) || "");
    };
    // convert masked/formatted national number value back to
    // just numbers for the actual form value
    var handleNationalNumber = function (evt) {
        var inputValue = evt.target.value;
        var rawNationalNumber = inputValue;
        var parsedNationalNumber = phoneNumbers_1.phoneNumbers.nationalNumber.getDigits(rawNationalNumber, format);
        setValue((value === null || value === void 0 ? void 0 : value.internationalCode) || "", parsedNationalNumber);
    };
    // strip out the international code if the user pastes in a whole number
    var beforeMaskedValueChange = function (newState, oldState, userInput) {
        var _a;
        if (!value)
            return newState;
        var intCodeLength = value.internationalCode.length;
        var isIntCodeIncluded = userInput && userInput.slice(0, intCodeLength) === value.internationalCode;
        if (isIntCodeIncluded) {
            var formattedWithoutIntCode = isIntCodeIncluded
                ? string_1.formatValue((_a = inputMaskEl.current) === null || _a === void 0 ? void 0 : _a.maskOptions, userInput.slice(intCodeLength))
                : null;
            return __assign(__assign({}, newState), { value: formattedWithoutIntCode });
        }
        else {
            return newState;
        }
    };
    var placeholderEl = (value === null || value === void 0 ? void 0 : value.nationalNumber) ? null : (react_1.default.createElement(common_1.Placeholder, null,
        react_1.default.createElement("span", null, format)));
    var inputEl = (react_1.default.createElement(common_1.TextInput, { as: react_input_mask_1.default, beforeMaskedValueChange: beforeMaskedValueChange, formatChars: { "0": "[0-9]" }, mask: format, maskChar: null, name: name, onBlur: onBlur, onChange: handleNationalNumber, ref: inputMaskEl, value: (value === null || value === void 0 ? void 0 : value.nationalNumber) || "" }));
    var lineEl = disabled ? null : react_1.default.createElement(common_1.Line, { hasError: showError });
    var errorEl = showError ? react_1.default.createElement(ErrorMessage_1.default, { children: error }) : null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Wrapper, null,
            react_1.default.createElement(CountrySelect_1.default, { value: (value === null || value === void 0 ? void 0 : value.internationalCode) || "", onChange: handleInternationalCode }),
            react_1.default.createElement(NationalNumberWrapper, null,
                placeholderEl,
                inputEl),
            lineEl),
        errorEl));
};
exports.default = PhoneField;
var templateObject_1, templateObject_2;
